import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Background from 'components/common/Background';
import Flex from 'components/common/Flex';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import corner1 from 'assets/img/icons/spot-illustrations/corner-3.png';
import PropTypes from 'prop-types';
import FalconCardHeader from 'components/common/FalconCardHeader';
import CardDropdown from 'components/common/CardDropdown';

const Greetings = ({ data, showBg = true }) => {
  return (
    <Card className="h-100">
      {showBg && (
        <Background image={corner1} className="rounded-soft bg-card" />
      )}
      <FalconCardHeader
        title={
          <div>
            <h2 className="text-primary">
              <FontAwesomeIcon icon="lightbulb" /> Hello, Ahmed !
            </h2>
            <h6 className="text-600">
              Here are some quick links for you to start
            </h6>
          </div>
        }
        light={false}
        titleTag="div"
        className="pb-1"
        menuClassName="align-items-start"
        endEl={<CardDropdown btnRevealClass="btn-falcon-default" />}
      />

      <Card.Body className="z-index-1">
        <Row className="g-2 h-100 align-items-end">
          {data.map(({ icon, color, title, text }) => {
            return (
              <Col sm={6} md={5} xl key={title}>
                <Flex className="position-relative">
                  <div className="icon-item icon-item-sm border rounded-3 shadow-none me-2">
                    <FontAwesomeIcon icon={icon} className={`text-${color}`} />
                  </div>
                  <div className="flex-1">
                    <Link to="#!" className="stretched-link text-800">
                      <h6 className="mb-0">{title}</h6>
                    </Link>
                    <p className="mb-0 fs--2 text-500 ">{text}</p>
                  </div>
                </Flex>
              </Col>
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
};

Greetings.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired
    })
  ),
  showBg: PropTypes.bool
};

export default Greetings;
